<template>
  <div>
    <div class="list-group list-group-flush">
      <div
        class="list-group-item d-flex mb-1 align-items-center"
        v-for="gn in genes"
        :key="gn.olab_id"
      >
        <div class="col-1 m-auto">
          <!-- NOP -->
        </div>
        <div class="col-3 mx-2">
          <OlabSampleSVGGen name="Gene" textPosX="265" textPosY="395" />
        </div>

        <div class="col text-wrap">
          <a
            class="h3 text-info"
            data-toggle="modal"
            href="#geneDetailInfo"
            v-on:click="registerGene(gn)"
            data-backdrop="static"
            data-keyboard="false"
            >{{ gn.olab_id }}</a
          >

          <div
            v-if="selectedGene != null"
            class="modal fade"
            id="geneDetailInfo"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    OLAB ID:
                    <span class="h5 text-dark">{{ selectedGene.olab_id }}</span>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <!-- .modal-header -->
                <div class="modal-body">
                  <div class="text-wrap">
                    <span v-if="selectedGene.name">
                      <span class="font-italic mr-1">Name:</span>
                      <span class="h5 text-dark mr-5">{{
                        selectedGene.name
                      }}</span>
                    </span>
                    <span v-if="selectedGene.synonym_name1">
                      <span class="font-italic mr-1">Synonym Name:</span>
                      <span
                        v-if="selectedGene.synonym_name1"
                        class="h5 text-dark"
                        >{{ selectedGene.synonym_name1 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name2"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name2 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name3"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name3 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name4"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name4 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name5"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name5 }}</span
                      >
                    </span>
                  </div>
                  <div v-if="selectedGene.b_number" class="py-1 text-wrap">
                    <span class="font-italic mr-1">B Number:</span>
                    <span class="h5 text-dark">{{
                      selectedGene.b_number
                    }}</span>
                  </div>
                  <div v-if="selectedGene.product" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Product:</span>
                    <span class="h5 text-dark">{{ selectedGene.product }}</span>
                  </div>
                  <div
                    v-if="selectedGene.locus_tag || selectedGene.old_locus_tag"
                    class="my-2 card"
                  >
                    <div class="card-header text-dark">Locus Tag</div>
                    <div class="card-body text-wrap">
                      <span class="font-italic mr-1">Old:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.old_locus_tag
                      }}</span>

                      <span class="font-italic ml-3 mr-1">New:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.locus_tag
                      }}</span>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <div class="my-2 card">
                    <div class="card-header text-dark">Description</div>
                    <div class="card-body">
                      <div class="py-1 small font-italic text-dark text-wrap">
                        {{ selectedGene.desc }}
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                  <div v-if="selectedGene.sequence != null" class="card">
                    <div class="card-header text-dark">Sequence</div>
                    <div class="card-body">
                      <span class="font-italic mr-1">Type:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.sequence.type
                      }}</span>
                      <div class="pt-2">
                        <span class="mr-1">Range:</span>
                        <span class="h5 font-italic text-dark"
                          >[ {{ selectedGene.sequence.from }},</span
                        >
                        <span class="h5 font-italic">..,</span>
                        <span class="h5 font-italic text-dark"
                          >{{ selectedGene.sequence.to }} ]</span
                        >
                        <span class="ml-5 mr-1">Strand:</span>
                        <span class="h5 font-italic text-dark">{{
                          selectedGene.sequence.comp | convertCompToStrand
                        }}</span>
                      </div>
                      <div class="py-2">
                        <span class="font-italic mr-1">Length:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.len
                        }}</span>
                      </div>
                      <div class="py-1">
                        <span class="font-italic mr-1"># A:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_a
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># C:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_c
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># G:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_g
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># T:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_t
                        }}</span>
                      </div>

                      <div
                        class="py-2 small text-monospace text-dark text-wrap"
                      >
                        {{ selectedGene.sequence.seq }}
                      </div>
                      <!-- <img class="card-img-bottom img-fluid" v-bind:alt="selectedGene.name" v-bind:src="printGeneImageLink"> -->
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
                <!-- .modal-body -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
                <!-- .modal-footer -->
              </div>
              <!-- .modal-content -->
            </div>
            <!-- .modal-dialog .modal-lg-->
          </div>
          <!-- .modal fade #geneDetailInfo -->

          <div class="h5 mt-2">
            <span v-if="gn.name" class="mr-2">{{ gn.name }}</span>
            <span v-if="gn.synonym_name1">{{ gn.synonym_name1 }}</span>
            <span v-if="gn.synonym_name2">; {{ gn.synonym_name2 }}</span>
            <span v-if="gn.synonym_name3">; {{ gn.synonym_name3 }}</span>
            <span v-if="gn.synonym_name4">; {{ gn.synonym_name4 }}</span>
            <span v-if="gn.synonym_name5">; {{ gn.synonym_name5 }}</span>
          </div>
          <div class="h5 text-truncate">
            <span v-if="gn.old_locus_tag" class="mr-3">{{
              gn.old_locus_tag
            }}</span>
            <span v-if="gn.locus_tag" class="mr-3">{{ gn.locus_tag }}</span>
            <span v-if="gn.b_number">{{ gn.b_number }}</span>
          </div>
          <div class="mb-0 text-monospace text-truncate">
            {{ gn.gene_stats.short_seq }}
          </div>
          <div class="h5">
            {{ gn.gene_stats.len }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import OlabSampleSVGGen from "@/components/OlabSampleSVGGen";
import { OlabGene } from "../olab/olabgene.js";
// import { OlabUtils } from "../olab/olabutils.js";

export default {
  name: "databaseitemlist",
  data: function() {
    return {
      selectedGene: null,
      gene: new OlabGene()
    };
  },
  props: ["user", "genes", "error", "selectedType"],
  components: {
    // FontAwesomeIcon,
    OlabSampleSVGGen
  },
  filters: {
    convertCompToStrand: function(value) {
      // console.log("value = " + value + ", (value == true) = " +  (value == true));
      return value == "true" ? "-" : "+";
    }
  },
  methods: {
    registerGene: function(gn) {
      this.selectedGene = gn;
      // OlabUtils.infoLog("registerGene: gene = " + gn);
      this.gene.set(gn);
    }
  }
};
</script>
